// The speakeasy landing: a warm coffee-dark void with the words "This is not for
// everyone." floating over a real Google sign-in button. Success flips AuthContext's
// `corp` → Home redirects to /create; failure (unverified, popup blocked/cancelled)
// leaves you here with a retry prompt.
import { useState } from "react";
import type { JSX } from "react";
import { signInCorp } from "@/lib/auth";
import styles from "./BackRoom.module.css";

export function BackRoom(): JSX.Element {
  const [pending, setPending] = useState(false);
  const [rejected, setRejected] = useState(false);

  const knock = () => {
    setPending(true);
    setRejected(false);
    // success: AuthContext flips `corp`, Home redirects to /create — nothing to do here.
    // failure (unverified, popup blocked/cancelled): show a retry prompt.
    signInCorp()
      .catch(() => setRejected(true))
      .finally(() => setPending(false));
  };

  return (
    <div className={styles.room}>
      <p className={styles.lettering}>This is not for everyone.</p>
      {rejected && <p className={styles.reject}>That didn&rsquo;t go through — try again.</p>}
      <button className={styles.google} onClick={knock} disabled={pending}>
        <span className={styles.g} aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
          </svg>
        </span>
        Sign in with Google
      </button>
    </div>
  );
}
